import * as React from 'react'
import { DownTime } from '../../model/DownTime'

type Props = {
  property: string
  downtime: DownTime
}

export class ValidationMessageList extends React.Component<Props> {
  isPropertyValid = (property: string): boolean => {
    return this.props.downtime.GetAllValidationMessagesForProperty(property).length === 0
  }

  render(): JSX.Element {
    return (
      <div>
        {' '}
        {!this.isPropertyValid(this.props.property) && (
          <div>
            <ul className="text-danger" style={{ paddingInlineStart: 15 }}>
              {this.props.downtime
                .GetAllValidationMessagesForProperty(this.props.property)
                .map(validationMessage => {
                  return (
                    <li key={this.props.downtime.id + validationMessage.message}>
                      {validationMessage.message}
                    </li>
                  )
                })}
            </ul>
          </div>
        )}
      </div>
    )
  }
}

export default ValidationMessageList
